import { apiFetcher } from '~/apis/api-fetcher';
import { HomeLayout } from '~/apis/mercari/models';

export const getHomeLayouts = async () => {
  return apiFetcher.get<HomeLayout>('/api/mercari/v2/home-layouts');
};
